import { motion } from "framer-motion";
import PageWrapper from "../components/PageWrapper";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faGlobe, faSatellite, faSatelliteDish } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom'; // <--- IMPORTANT: Import Link here!

export default function Explore() {
  const sections = [
    { title: "Stars", desc: "Massive luminous spheres of plasma that shine through nuclear fusion.", icon: faStar, path: "/stars" }, // Added path
    { title: "Planets", desc: "Celestial bodies orbiting stars, like our Earth or Jupiter.", icon: faGlobe, path: "/planets" }, // Added path
    { title: "Galaxies", desc: "Collections of stars, gas, and dark matter bound together by gravity.", icon: faSatelliteDish, path: "/galaxies" }, // Added path
    { title: "Satellites", desc: "Artificial or natural bodies orbiting planets.", icon: faSatellite, path: "/satellites" }, // Added path
  ];

  return (
    <PageWrapper>
      <div className="flex flex-col items-center justify-center min-h-screen p-8 text-white bg-gradient-to-br ">
        <h2 className="mb-12 text-5xl font-extrabold text-center text-blue-400 drop-shadow-lg">
          Explore the Universe
        </h2>
        <div className="flex flex-col items-stretch justify-center max-w-6xl gap-8 mx-auto md:flex-row">
          {sections.map((item, index) => (
            <motion.div
              key={index}
              className="relative flex-1 max-w-sm p-8 overflow-hidden transition-all duration-300 ease-in-out bg-gray-800 border shadow-2xl cursor-pointer rounded-3xl border-blue-500/30 group hover:scale-105 hover:shadow-blue-500/30"
              initial={{ opacity: 0, y: 50, rotateX: 10 }}
              whileInView={{ opacity: 1, y: 0, rotateX: 0 }}
              transition={{ delay: index * 0.15, type: "spring", stiffness: 100, damping: 10 }}
              whileHover={{ translateY: -10, rotateZ: 2, scale: 1.02 }}
              viewport={{ once: true, amount: 0.3 }}
            >
              <div className="absolute inset-0 bg-gradient-to-br from-gray-900 to-gray-800 opacity-70 rounded-3xl"></div>
              <div className="absolute inset-0 transition-all duration-300 border-4 border-transparent group-hover:border-blue-600/50 rounded-3xl"></div>

              <div className="relative z-10 flex flex-col items-center h-full text-center">
                {/* Icon */}
                {item.icon && (
                  <motion.div
                    className="mb-4 text-6xl text-blue-400 drop-shadow-lg"
                    initial={{ scale: 0.8 }}
                    animate={{ scale: 1 }}
                    transition={{ delay: index * 0.15 + 0.3, type: "spring", stiffness: 150, damping: 12 }}
                  >
                    <FontAwesomeIcon icon={item.icon} />
                  </motion.div>
                )}

                <h3 className="mb-4 text-4xl font-extrabold text-blue-300 drop-shadow-md">
                  {item.title}
                </h3>
                <p className="flex-grow mb-6 text-lg leading-relaxed text-gray-300">
                  {item.desc}
                </p>

                {/* --- THIS IS THE CRUCIAL CHANGE --- */}
                {/* Replace <button> with <Link> and use the 'to' prop for navigation */}
                <Link
                  to={item.path} // Use the path from the section item
                  className="px-6 py-3 mt-auto text-lg font-semibold text-white no-underline transition-all duration-300 ease-in-out bg-blue-600 rounded-full shadow-lg hover:bg-blue-700 hover:shadow-blue-500/50" // Added no-underline for styling
                >
                  Learn More
                  <span className="ml-2">→</span>
                </Link>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </PageWrapper>
  );
}